export default __webpack_public_path__ + "static/media/squid-moon-bg-music.de1c0924.mp3";